export enum AvatarAppearance {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
